export default __webpack_public_path__ + "static/media/download-icon.034f9251.svg";